import { Alert, Button, Popover } from "react-bootstrap";
import moment from "moment-jalali";
import Loader from "react-loader-spinner";
import { CheckLg, DashCircle, ExclamationTriangle, List, Pencil } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faTimes } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker2";
import { addEditCard } from "../store/api/GuaranteeApi";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";

export default function PopGuaranteeCard({
    currentCard,
    filterData,
    setCurrentCard,
    search,
    showModalStorage,
    showModalProduct,
    showModalAgency,
    holderList,
    allowNoProduct }) {

    const dispatch = useDispatch();
    const [cancelConfirm, setCancelConfirm] = useState(false);
    const addMonth = (month) => {
        if (currentCard.GuaranteeStartDate && currentCard.GuaranteeStartDate !== '') {
            const m = moment(currentCard.GuaranteeStartDate);
            const endDt = m.add("jMonth", Number(month));
            currentCard.GuaranteeTimeInMonth = month;
            setCurrentCard({ ...currentCard, GuaranteeEndDate: endDt.local("en").format("YYYY-MM-DD") });

        }
    }
    function addEdit(confirmedCancel) {
        if (!confirmedCancel && currentCard.IsGuaranteeCanceled) {
            setCancelConfirm(true);
            return;
        }
        if (currentCard.IsUsedInServices && !currentCard.IsGuaranteeCanceled) {
            setErrorDialog(dispatch, "این کارت استفاده شده و امکان ویرایش آن وجود ندارد", "کارت گارانتی");
            return;
        }
        if ((!allowNoProduct && (currentCard.HolderID ?? "") === "" && (currentCard.ProductID ?? "") === "") || (allowNoProduct && (currentCard.SerialNumber ?? "") === "")) {
            return;
        }
        const onAddEdit = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, (Number(currentCard.CardID) > 0 ? "ویرایش" : "ثبت") + ` کارت گارانتی`);
                setCancelConfirm(false);
                return;
            }
            else if (res.Data) {
                setCurrentCard(null);
                setCancelConfirm(false);
                setErrorDialog(dispatch, "success", (Number(currentCard.CardID) > 0 ? "ویرایش" : "ثبت") + " کارت گارانتی");
            }
            search(filterData ?? {});
        }
        const cardData = (({ e, ...data }) => data)(currentCard);
        cardData.ID = currentCard.CardID;
        addEditCard(cardData, cardData.StorageID, onAddEdit);
    }
    const posStyle = useMemo(() => {
        if (currentCard?.e) {
            return {
                left: currentCard.e.pageX + 15,
                top: currentCard.e.pageY - 300
            };
        }
        return { display: "none" };
    }, [currentCard]);
    if (!currentCard || !currentCard.e) return null;
    return (

        <Popover id="popEditCard" style={{ fontSize: "13px", fontFamily: "Vazir", maxWidth: "400px", minWidth: "400px", ...posStyle }} className="mt-5">
            <Popover.Title as="h3" className="headerStyle">
                <span>  <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;{Number(currentCard.CardID) > 0 ? "ویرایش " : "ثبت "}  کارت گارانتی {Number(currentCard.InvoiceID) > 0 ? "[رسید دارد]" : ""}</span>
                <label style={{ float: "left" }}><FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setCurrentCard(null)} /></label>
                {Number(currentCard.CardID) > 0 &&
                    <div style={{ display: "inline-block", fontSize: "11px" }}>
                        {"["}
                        <span>تاریخ ثبت: </span>
                        <label>{currentCard.PCreationDate}</label>
                        {"]"}
                    </div>
                }
            </Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <table style={{ width: "100%", fontSize: "12px" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: "100px" }}>نام برند:</td>
                            <td colSpan="100%">
                                {
                                    Array.isArray(holderList ?? "") ?
                                        <select className="tableRowInput" onChange={e => currentCard.HolderID = e.target.value} defaultValue={currentCard.HolderID}>
                                            <option value="">انتخاب کنید</option>
                                            {holderList.map((item, i) =>
                                                <option key={i} value={item.ID}>{item.HolderName}</option>)
                                            }
                                        </select> :
                                        <div className="tableRowInput">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>نمایندگی: </td>
                            <td colSpan="100%">
                                <div>
                                    <input className="tableRowInput" value={currentCard.AgencyName ?? ""} readOnly />
                                    <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalAgency}><List size={17} /></Button>
                                </div>
                            </td>
                        </tr>
                        {Number(currentCard.AgencyID) > 0 && currentCard.AssignToAgencyDate &&
                            <tr>
                                <td>تاریخ تخصیص به نمایندگی: </td>
                                <td colSpan="100%">
                                    <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0"
                                        value={moment(currentCard.AssignToAgencyDate.substring(0, 10))} readOnly disabled />

                                </td>
                            </tr>
                        }
                        <tr>
                            <td>مشخصات محصول: </td>
                            <td colSpan="100%">
                                <div>
                                    <input className="tableRowInput" value={(currentCard.ProductName ?? "") + "-" + (currentCard.ProductModel ?? "")} />
                                    <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalProduct}><List size={17} /></Button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>شماره کارت/سریال: </td>
                            <td colSpan={3}>
                                <input className="tableRowInput" placeholder="شماره کارت" title="شماره کارت" defaultValue={currentCard.GuaranteeCardNo} onChange={e => currentCard.GuaranteeCardNo = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </td>
                            <td colSpan={3}>
                                <input className="tableRowInput" title="شماره سریال" placeholder="شماره سریال" defaultValue={currentCard.SerialNumber} onChange={e => currentCard.SerialNumber = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </td>
                        </tr>
                        <tr>
                            <td>نام فروشگاه: </td>
                            <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.ShopName ?? ""} onChange={e => currentCard.ShopName = e.target.value} /></td>
                        </tr>
                        <tr>
                            <td>هزینه کارت: </td>
                            <td colSpan="100%"><input className="tableRowInput" type="number" defaultValue={currentCard.CardPrice ?? ""} onChange={e => currentCard.CardPrice = e.target.value} /></td>
                        </tr>
                        <tr>
                            <td>تاریخ و مدت:</td>
                            <td colSpan={2}>
                                <DatePicker timePicker={false} isGregorian={false} placeholder="آغاز گارانتی" className="tableRowInput mt-0"
                                    value={(currentCard.GuaranteeStartDate ?? "") !== "" ? moment(currentCard.GuaranteeStartDate.substring(0, 10)) : null}
                                    onChange={val => setCurrentCard({ ...currentCard, GuaranteeStartDate: val.local("en").format("YYYY-MM-DD") })} />
                            </td>
                            <td colSpan={2} ><input style={{ color: "blue" }} placeholder="مدت گارانتی" className="tableRowInput" type="number" onChange={e => addMonth(e.target.value)} value={currentCard.GuaranteeTimeInMonth ?? 0} /></td>
                            <td colSpan={2}>
                                <DatePicker timePicker={false} isGregorian={false} placeholder="پایان گارانتی" className="tableRowInput mt-0"
                                    value={(currentCard.GuaranteeEndDate ?? "") !== "" ? moment(currentCard.GuaranteeEndDate.substring(0, 10)) : null}
                                    onChange={val => setCurrentCard({ ...currentCard, GuaranteeEndDate: val.local("en").format("YYYY-MM-DD") })} />
                            </td>
                        </tr>
                        <tr>
                            <td>تاریخ تولید/خرید: </td>
                            <td colSpan="3">
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="تاریخ تولید"
                                    value={(currentCard.ProductCreationDate ?? "") !== "" ? moment(currentCard.ProductCreationDate.substring(0, 10)) : null}
                                    onChange={val => setCurrentCard({ ...currentCard, ProductCreationDate: val.local("en").format("YYYY-MM-DD") })} />
                            </td>
                            <td colSpan="3">
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="تاریخ خرید"
                                    value={(currentCard.PurchaseDate ?? "") !== "" ? moment(currentCard.PurchaseDate.substring(0, 10)) : null}
                                    onChange={val => setCurrentCard({ ...currentCard, PurchaseDate: val.local("en").format("YYYY-MM-DD") })} />
                            </td>
                        </tr>
                        <tr>
                            <td>محل/اپراتور تولید: </td>
                            <td colSpan={3}><input className="tableRowInput" placeholder="محل تولید" defaultValue={currentCard.Manufacturer ?? ""} onChange={e => currentCard.Manufacturer = e.target.value} /></td>
                            <td colSpan={3}><input className="tableRowInput" placeholder="اپراتور تولید" defaultValue={currentCard.ProductionOperator ?? ""} onChange={e => currentCard.ProductionOperator = e.target.value} /></td>
                        </tr>
                        <tr>
                            <td>مهلت نصب/فعالسازی: </td>
                            <td colSpan="3">
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="مهلت نصب"
                                    disabled={!(currentCard.CanEditInstallDeadline ?? true)}
                                    value={(currentCard.InstallDeadline ?? "") !== "" ? moment(currentCard.InstallDeadline.substring(0, 10)) : null}
                                    onChange={val => {
                                        //کاربر وقتی تاریخ را پاک می کند تاریخ کامپوننت تاریخ امروز را به خود می گیرد که درست نیست.
                                        // تنها راه این است که اگر تاریخ امروز بود آنرا برابر null در نظر بگیریم
                                        let newDate = null;
                                        if (!(val && val.isSame(moment(), "day"))) {
                                            newDate = val?.format("YYYY-MM-DD") ?? "";
                                        }
                                        //  از updater function استفاده می‌کنیم تا از stale state جلوگیری کنیم.
                                        // دلیلش اینه که اگر از currentCard مستقیم استفاده کنیم، ممکنه نسخه قدیمی باشه
                                        // چون onChange ممکنه با closure قدیمی ساخته شده باشه (قبل از آخرین تغییر state).
                                        // بنابراین همیشه از prev => {...} استفاده می‌کنیم تا مطمئن باشیم آخرین state رو داریم.
                                        // دلیل شفاهی این کار هم اینه که وقتی از بیرون مقدار InstallDeadline تغییر میکرد onChange هم فراخوانی میشد که باعث رندر اضافه میشد
                                        setCurrentCard((prev) => {
                                            if (newDate !== prev?.InstallDeadline) {
                                                return { ...prev, InstallDeadline: newDate };
                                            }
                                            return prev;
                                        });
                                    }
                                    } />
                            </td>
                            <td colSpan="3">
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput mt-0" placeholder="مهلت فعالسازی"
                                    value={(currentCard.ActiveDeadline ?? "") !== "" ? moment(currentCard.ActiveDeadline.substring(0, 10)) : null}
                                    onChange={val => {
                                        //کاربر وقتی تاریخ را پاک می کند تاریخ کامپوننت تاریخ امروز را به خود می گیرد که درست نیست.
                                        // تنها راه این است که اگر تاریخ امروز بود آنرا برابر null در نظر بگیریم
                                        let newDate = null;
                                        if (!(val && val.isSame(moment(), "day"))) {
                                            newDate = val?.format("YYYY-MM-DD") ?? "";
                                        }
                                        //  از updater function استفاده می‌کنیم تا از stale state جلوگیری کنیم.
                                        // دلیلش اینه که اگر از currentCard مستقیم استفاده کنیم، ممکنه نسخه قدیمی باشه
                                        // چون onChange ممکنه با closure قدیمی ساخته شده باشه (قبل از آخرین تغییر state).
                                        // بنابراین همیشه از prev => {...} استفاده می‌کنیم تا مطمئن باشیم آخرین state رو داریم.
                                        // دلیل شفاهی این کار هم اینه که وقتی از بیرون مقدار InstallDeadline تغییر میکرد onChange هم فراخوانی میشد که باعث رندر اضافه میشد
                                        setCurrentCard((prev) => {
                                            if (newDate !== prev?.ActiveDeadline) {
                                                return { ...prev, ActiveDeadline: newDate };
                                            }
                                            return prev;
                                        });
                                    }
                                    } />
                            </td>                            
                        </tr>
                        <tr>
                            <td title="شناسه رهگیری وزارت صنعت، معدن و تجارت">شناسه رهگیری: </td>
                            <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.MIMTTrackingID ?? ""} onChange={e => currentCard.MIMTTrackingID = e.target.value} /></td>
                        </tr>
                        <tr>
                            <td>شناسه تولید: </td>
                            <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.ProductionID ?? ""} onChange={e => currentCard.ProductionID = e.target.value} /></td>
                        </tr>                        
                        {Number(currentCard.CardID) > 0 &&
                            <>
                                <tr>
                                    <td>ابطال گارانتی: </td>
                                    <td><input className="form-check-input" type="checkbox" defaultChecked={currentCard.IsGuaranteeCanceled ?? ""} onChange={e => currentCard.IsGuaranteeCanceled = e.target.checked} /></td>
                                </tr>
                                <tr>
                                    <td>شرح ابطال: </td>
                                    <td colSpan="100%"><input className="tableRowInput" defaultValue={currentCard.CancelDescription ?? ""} onChange={e => currentCard.CancelDescription = e.target.value} /></td>
                                </tr>
                            </>
                        }
                        {!(Number(currentCard.InvoiceID) > 0) && !currentCard.IsUsedInServices && !currentCard.IsActive &&
                            <tr>
                                <td>انبار ثبت رسید:</td>
                                <td colSpan="100%">
                                    <div>
                                        <input className="tableRowInput" onKeyDown={showModalStorage} value={currentCard.StorageName ?? ""} readOnly />
                                        <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalStorage}><List size={17} /></Button>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                <div className="mt-2">
                    {cancelConfirm && <Alert variant="warning">
                        <span>
                            <ExclamationTriangle size={18} />&nbsp;
                            آیا از ابطال گارانتی مطمئن هستید؟
                            <Button className="group-Btn-smalll" variant="success" onClick={() => addEdit(true)}><CheckLg size={18} /> بله</Button>
                            <Button className="group-Btn-smalll" variant="danger" onClick={() => setCancelConfirm(false)}><DashCircle size={18} /> خیر</Button>
                        </span>
                    </Alert>}
                    {!cancelConfirm &&
                        <Button className="group-Btn" variant="success" onClick={() => addEdit()}>
                            {Number(currentCard.CardID) > 0 ?
                                <>
                                    <Pencil size={16} />&nbsp;ویرایش کارت
                                </> :
                                <>
                                    <CheckLg size={16} />&nbsp;ثبت کارت
                                </>
                            }
                        </Button>
                    }
                </div>
            </Popover.Content>
        </Popover>
    )
}